(function () {
  'use strict';

  var GEO_ENDPOINT = 'https://geo.shopaleena.com/api/geo';
  var STORAGE_KEY = 'shopaleena_geo';
  var MAX_AGE_MS = 24 * 60 * 60 * 1000; // 24 hours

  // Read cached geo if it exists and is still fresh
  function getCachedGeo() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      if (!raw) return null;

      var cached = JSON.parse(raw);
      if (!cached || !cached.timestamp) return null;

      var age = Date.now() - cached.timestamp;
      if (age > MAX_AGE_MS) return null; // expired

      return cached.data;
    } catch (e) {
      return null; // corrupt JSON, private mode, etc.
    }
  }

  // Persist geo data with a timestamp
  function cacheGeo(data) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify({
        timestamp: Date.now(),
        data: data
      }));
    } catch (e) {
      // localStorage unavailable (private mode / quota) — ignore
    }
  }

  // Fetch fresh geo from the API
  function fetchGeo() {
    return fetch(GEO_ENDPOINT, { method: 'GET' })
      .then(function (res) {
        if (!res.ok) throw new Error('Geo request failed: ' + res.status);
        return res.json();
      })
      .then(function (data) {
        cacheGeo(data);
        return data;
      });
  }

  // Main entry point — returns a Promise that resolves with geo data
  function getGeo() {
    var cached = getCachedGeo();
    if (cached) {
      return Promise.resolve(cached);
    }
    return fetchGeo().catch(function (err) {
      console.warn('[geo] lookup failed:', err);
      return null; // never break the page
    });
  }

  // Expose globally so other scripts / theme sections can use it
  window.ShopaleenaGeo = { get: getGeo };

  // Auto-run on load and dispatch an event when ready
  getGeo().then(function (geo) {
    if (!geo) return;

    // Example: log it. Replace with your own logic.
    console.log('City:', geo.city, '| Country:', geo.country);

    // Fire a custom event so other parts of the theme can react
    document.dispatchEvent(new CustomEvent('geo:ready', { detail: geo }));
  });
})();